//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper } from 'swiper';

export default {
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },

    props: {
        itemsPerPage: {
            type: Number,
            default: 4
        },
        isCustomCrossselling: {
            default: ''
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    updated()
    {
        this.initializeCarousel();
    },

    methods:
    {
        initializeCarousel()
        {
            new Swiper(this.$refs.swiperCarousel.children[0], {
                spaceBetween  : 0,
                autoHeight    : false,
                slidesPerView : 2.25,
                freeMode      : true,
                cssMode       : true,
                allowTouchMove: true,
                breakpoints: {
                    768: {
                      spaceBetween  : 0,
                      slidesPerView : 3.25,
                    },
                    992: {
                      spaceBetween  : 8,
                      slidesPerView : 4,
                      cssMode       : false,
                      allowTouchMove: false
                    }
                },
                pagination: {
                    el        : this.$refs.swiperCarousel.children[0].children[1],
                    clickable : true,
                },
                navigation: {
                    nextEl: this.$refs.swiperCarousel.children[2],
                    prevEl: this.$refs.swiperCarousel.children[1],
                }
            })
        }

    }
}
